const architectureData = [
    {
        category: 'architecture',
        id: '1',
        alt: '',
        title: '',
        blurhash: 'L19%*V00%M0000~qM{D%00_3~q_3',
        orientation: 'portrait'
    },
    {
        category: 'architecture',
        id: '2',
        alt: '',
        title: '',
        blurhash: 'LAAmrF%M009F~qxu9FIU00Rj~qt7',
        orientation: 'portrait'
    },
    {
        category: 'architecture',
        id: '3',
        alt: '',
        title: '',
        blurhash: 'LA7K#P#*=LRj~BwI=|NG={RP%LRj',
        orientation: 'landscape'
    }
];

export default architectureData;
